import { FC, ReactNode } from "react";

import styles from "./IconBox.module.css";

interface Props {
  children: ReactNode;
  size?: "md" | "lg";
}

// Иконка в квадрате с подсвеченной рамкой — общий акцент страницы промо.
export const IconBox: FC<Props> = ({ children, size = "md" }) => (
  <span className={`${styles.box} ${styles[size]}`}>{children}</span>
);
